(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ShowcasesDetailController', ShowcasesDetailController);

    /** @ngInject */
    function ShowcasesDetailController($state, $timeout, $stateParams, $filter, $q, $window, $localStorage,
        StoreService, $scope, $translate, FlyersService, FlyerCategoryService, FlyersCurrencyValue,
        ShowcasesService, toastr, Principal, UserInteractModalFactory, ModalFactory, DOMAIN, $rootScope, $uibModal, systemConstants) {

        var vm = this;
        var userInteractModal;
        var storeId = $localStorage.defaultStore.storeId;
        vm.isImmoContext = !!$localStorage.defaultStore.immoContext;
        var mainColor = getComputedStyle(document.documentElement).getPropertyValue('--main-color');
        vm.showcaseId = $stateParams.showcaseId;
        var DEFAULT_TYPE = "SALE";
        vm.backgroundColorAux = '';
        vm.banners = [];
        vm.haveBanners = false;
        vm.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MAX_XS;

        vm.isPrinting = false;

        var DEFAULT_IMAGE = "https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/showkase/capa-loading-image-s3.png";

        vm.showcase = {
            'backgroundColor': false,
            flyers: [],
            ownerId: null,
            hasCover: false,
            userInteract: "SALE"
        };

        $scope.options = {
            format: 'hex',
            case: 'upper'
        }

        vm.listFilter = {
            storeId: storeId,
            activated: null,
            type: null
        };

        vm.openShowcaseModalType = openShowcaseModalType;

        vm.imageSize = 800;

		function loadCanvaAPI(c,a,n){
			var w=c.createElement(a),s=c.getElementsByTagName(a)[0];
			w.src=n;s.parentNode.insertBefore(w,s);
		}

		loadCanvaAPI (document,'script','https://sdk.canva.com/designbutton/v2/api.js');

        vm.storeOwnerHasMoipAccount = false;
        storeOwnerHasMoipAccount();
        vm.dynamicPopover = {
            templateUrl: 'userInteractPopoverTemplate.html',
        };
        vm.coverEdit = true;
        vm.templateIsLoading = true;
        vm.showcases = [1, 2, 3, 4, 5, 6, 7, 8];
        vm.templates = [];
        vm.flyersToLoad = 1;
        vm.isSaving = false;
		vm.saveImageCover = true;
        vm.isSavingPreview = false;
        vm.totalShowcaseFlyers = 0;
        vm.hasMoreFlyers = false;
        vm.isShowcaseFlyersSaveListLoading = false;

        var dragAutoScrollFrameId = null;
        var dragAutoScrollDirection = 0;
        var dragAutoScrollSpeed = 0;
        var dragAutoScrollMoveHandler = null;
        var dragAutoScrollContainerEl = null;

        function getScrollableParent(element) {
            var current = element;
            while (current && current !== document.body && current !== document.documentElement) {
                var style = $window.getComputedStyle(current);
                var overflowY = style ? style.overflowY : '';
                var isScrollableY = overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay';
                if (isScrollableY && current.scrollHeight > current.clientHeight) {
                    return current;
                }
                current = current.parentElement;
            }
            return null;
        }

        function stopDragAutoScroll() {
            if (dragAutoScrollFrameId) {
                $window.cancelAnimationFrame(dragAutoScrollFrameId);
                dragAutoScrollFrameId = null;
            }
            dragAutoScrollDirection = 0;
            dragAutoScrollSpeed = 0;

            if (dragAutoScrollMoveHandler) {
                document.removeEventListener('mousemove', dragAutoScrollMoveHandler, true);
                document.removeEventListener('touchmove', dragAutoScrollMoveHandler, true);
                dragAutoScrollMoveHandler = null;
            }
        }

        function runDragAutoScroll() {
            if (!dragAutoScrollDirection) {
                dragAutoScrollFrameId = null;
                return;
            }

            if (dragAutoScrollContainerEl) {
                dragAutoScrollContainerEl.scrollTop = dragAutoScrollContainerEl.scrollTop + (dragAutoScrollDirection * dragAutoScrollSpeed);
            } else {
                $window.scrollBy(0, dragAutoScrollDirection * dragAutoScrollSpeed);
            }
            dragAutoScrollFrameId = $window.requestAnimationFrame(runDragAutoScroll);
        }

        function updateDragAutoScroll(pointerClientY) {
            var threshold = 120;
            var minSpeed = vm.isMobile ? 2 : 8;
            var maxSpeed = vm.isMobile ? 7 : 28;
            var containerRect = dragAutoScrollContainerEl ? dragAutoScrollContainerEl.getBoundingClientRect() : null;
            var viewportTop = 0;
            var viewportBottom = $window.innerHeight || document.documentElement.clientHeight;
            var visibleTop = containerRect ? Math.max(containerRect.top, viewportTop) : viewportTop;
            var visibleBottom = containerRect ? Math.min(containerRect.bottom, viewportBottom) : viewportBottom;
            var topDistance = pointerClientY - visibleTop;
            var bottomDistance = visibleBottom - pointerClientY;
            var nextDirection = 0;
            var nextSpeed = 0;

            if (topDistance < threshold) {
                nextDirection = -1;
                nextSpeed = minSpeed + Math.round(((threshold - topDistance) / threshold) * (maxSpeed - minSpeed));
            } else if (bottomDistance < threshold) {
                nextDirection = 1;
                nextSpeed = minSpeed + Math.round(((threshold - bottomDistance) / threshold) * (maxSpeed - minSpeed));
            }

            if (!nextDirection) {
                stopDragAutoScroll();
                return;
            }

            dragAutoScrollDirection = nextDirection;
            dragAutoScrollSpeed = nextSpeed;

            if (!dragAutoScrollFrameId) {
                dragAutoScrollFrameId = $window.requestAnimationFrame(runDragAutoScroll);
            }
        }

        // Helper com .dragzone > .products para o clone no body receber os mesmos ancestrais CSS da lista.
        vm.showcaseFlyersSortableOptions = angular.extend({}, systemConstants.UI_SORTABLE_OPTIONS, {
            scroll: false,
            disableCenterOnPointer: vm.isMobile,
            handle: vm.isMobile ? '.showcase-sort-handle' : false,
            containment: vm.isMobile ? '.showcase-box-content .products' : false,
            helper: function (event, $item) {
                var $clone = $item.clone();
                var $wrapper = vm.isMobile ?
                    angular.element('<div class="dragzone mobile ui-sortable-helper-context"></div>') :
                    angular.element('<div class="dragzone ui-sortable-helper-context"></div>');
                var $ul = angular.element('<ul class="products no-scroll-overflow"></ul>');
                $ul.append($clone);
                $wrapper.append($ul);
                return $wrapper;
            },
            start: function () {
                dragAutoScrollContainerEl = getScrollableParent(this);

                dragAutoScrollMoveHandler = function (moveEvent) {
                    var clientY = null;
                    if (moveEvent.touches && moveEvent.touches.length) {
                        clientY = moveEvent.touches[0].clientY;
                    } else if (angular.isNumber(moveEvent.clientY)) {
                        clientY = moveEvent.clientY;
                    }

                    if (angular.isNumber(clientY)) {
                        updateDragAutoScroll(clientY);
                    }
                };

                document.addEventListener('mousemove', dragAutoScrollMoveHandler, true);
                document.addEventListener('touchmove', dragAutoScrollMoveHandler, true);
            },
            sort: function (event) {
                var clientY = event && angular.isNumber(event.clientY) ? event.clientY : null;
                if (!angular.isNumber(clientY) && event && event.originalEvent) {
                    if (event.originalEvent.touches && event.originalEvent.touches.length) {
                        clientY = event.originalEvent.touches[0].clientY;
                    } else if (angular.isNumber(event.originalEvent.clientY)) {
                        clientY = event.originalEvent.clientY;
                    }
                }

                if (angular.isNumber(clientY)) {
                    updateDragAutoScroll(clientY);
                }
            },
            stop: function () {
                stopDragAutoScroll();
                dragAutoScrollContainerEl = null;
            }
        });

        var showcaseFlyersPageSize = 20;
        var currentShowcaseFlyersPage = 0;
        var isLoadingMoreFlyers = false;

        loadAll();

        vm.openInputColor = function() {
            document.getElementsByClassName('pcr-button')[0].click();
        }

        vm.goToSettings = function () {
            $state.go('settings');
        }

        vm.openColorModal = function () {
            $uibModal.open({
                templateUrl: 'app/admin/showcases/select-colors-modal/select-colors-modal.html',
                controller: 'SelectColorsModalConstroller',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'lg',
                keyboard: false,
                resolve: {
                    colors: function () {
                        return {
                            backgroundColor: vm.showcase.backgroundColor,
                            headerBackgroundColor: vm.showcase.headerBackgroundColor,
                            iconColor: vm.showcase.headerIconColor
                        }
                    }
                },
            }).result.then(function (response) {
                if (response) {
                    vm.showcase.backgroundColor = response.backgroundColor;
                    vm.showcase.headerBackgroundColor = response.headerBackgroundColor;
                    vm.showcase.headerIconColor = response.iconColor;
                    document.getElementsByClassName('icon-ksc-colorselection')[0].style.color = response.backgroundColor;
                }
            });
        }

        function loadAll() {
            vm.templateId = 1; // Chose the first template as default
            ShowcasesService.getTemplates().then(function (response) {
                vm.templates = response;
            });
            FlyerCategoryService.listCategories($translate.use()).then(function(response) {
                vm.categories = response.data;
            });
            if (vm.showcaseId) {
                loadShowcase();
            } else {
                vm.showcase.ownerId = storeId;
                vm.showcase.backgroundColor = mainColor;
                vm.showcase.headerBackgroundColor = mainColor;
                vm.backgroundColorAux = mainColor;
                vm.showcase.showcaseTemplateId = vm.templateId;
                vm.templateIsLoading = false;
            }
        }

        function loadShowcase() {
            return ShowcasesService.getShowcase(vm.showcaseId, null, false).then(function (response) {
                vm.showcase = response;
                vm.backgroundColorAux = vm.showcase.backgroundColor;
                vm.showcase.userInteract = vm.originalUserInteract ? vm.originalUserInteract: vm.showcase.userInteract;

                if(vm.showcase.banners != null && vm.showcase.banners.length > 0) {
                    vm.banners = vm.showcase.banners;
                    vm.haveBanners = true;
                    vm.showcase.banners.forEach(function(banner, i) {
                        vm.banners[i].image = vm.showcase.coverUrl.split("showcase")[0] + vm.banners[i].cover;

                        if (vm.banners[i].coverMobile) {
                            vm.banners[i].imageMobile = vm.showcase.coverUrl.split("showcase")[0] + vm.banners[i].coverMobile;
                        }
                    })
                } else if (vm.showcase.hasCover && vm.showcase.coverUrl !== '') {
                    checkImage(function (url) {
                        vm.banners.push({'id': 1, 'image': url, 'name': '', 'link': ''});
                        loadCarousel();
                    });
                    vm.haveBanners = true;
                }

                loadCarousel();
                return loadInitialShowcaseFlyers();
            });
        }

        function resetShowcaseFlyersPagination() {
            currentShowcaseFlyersPage = 0;
            isLoadingMoreFlyers = false;

            vm.totalShowcaseFlyers = 0;
            vm.hasMoreFlyers = false;
            vm.showcase.flyers = [];
        }

        function enrichShowcaseFlyer(flyer) {
            vm.getCategoryName(flyer);
            flyer.imagePath = getFlyerImageWithResolution(flyer, systemConstants.IMAGE_RESOLUTIONS.GALLERY_CARD);
            return flyer;
        }

        function loadInitialShowcaseFlyers() {
            resetShowcaseFlyersPagination();
            return loadNextShowcaseFlyersPage();
        }

        vm.loadMoreShowcaseFlyers = function () {
            return loadNextShowcaseFlyersPage();
        };

        function loadNextShowcaseFlyersPage() {
            if (!vm.showcase || !vm.showcase.id || isLoadingMoreFlyers || (!vm.hasMoreFlyers && currentShowcaseFlyersPage > 0)) {
                return $q.when();
            }

            isLoadingMoreFlyers = true;
            return ShowcasesService.getShowcaseFlyersPage(vm.showcase.id, vm.showcase.ownerId, {
                page: currentShowcaseFlyersPage,
                size: showcaseFlyersPageSize
            }).then(function (response) {
                var flyers = (response && response.data) ? response.data : [];
                var headers = (response && response.headers) ? response.headers : {};
                var totalFromHeader = parseInt(headers['x-total-count'], 10);
                var hasNextPageHeader = headers['x-has-next-page'] === 'true';

                vm.totalShowcaseFlyers = isNaN(totalFromHeader) ? vm.totalShowcaseFlyers : totalFromHeader;
                currentShowcaseFlyersPage = currentShowcaseFlyersPage + 1;

                Array.prototype.push.apply(vm.showcase.flyers, flyers.map(enrichShowcaseFlyer));
                vm.hasMoreFlyers = hasNextPageHeader || (vm.totalShowcaseFlyers > vm.showcase.flyers.length);
                loadTemplate();
            }).finally(function () {
                isLoadingMoreFlyers = false;
            });
        }

        function mergeShownShowcaseFlyersToShowcase() {
            vm._shownShowcaseFlyersBeforeMerge = vm.showcase && vm.showcase.flyers ? vm.showcase.flyers.slice() : [];
            if (!vm.showcase || !vm.showcase.id) {
                return $q.when();
            }
            vm.isShowcaseFlyersSaveListLoading = true;
            var shown = vm._shownShowcaseFlyersBeforeMerge.slice();

            return ShowcasesService.getShowcaseFlyers(vm.showcase.id, vm.showcase.ownerId).then(function (allFlyers) {
                allFlyers = allFlyers || [];
                var flyerIds = shown.map(function (f) {
                    return f.id;
                });
                var tail = [];
                angular.forEach(allFlyers, function (f) {
                    if (flyerIds.indexOf(f.id) === -1) {
                        tail.push(f);
                    }
                });
                var merged = shown.concat(tail);
                angular.forEach(merged, function (flyer) {
                    enrichShowcaseFlyer(flyer);
                });
                vm.showcase.flyers = merged;
            }, function () {
                vm.isShowcaseFlyersSaveListLoading = false;
            });
        }

        function checkImage(callback) {
            var image = new Image();
            image.onload = function () {
                if (this.width > 0) {
                    callback(vm.showcase.coverUrl);
                }
            }
            image.onerror = function () {
                callback(DEFAULT_IMAGE);
            }
            image.src = vm.showcase.coverUrl;
        }

        vm.checkFlyerIsSelected = function (id) {
            if (vm.flyersMap) {
                return angular.isDefined(vm.flyersMap[id]);
            }
        };

        vm.changeFlyerSelected = function (flyer) {
            if (vm.flyersMap) {
                if (vm.flyersMap[flyer.id]) {
                    vm.showcase.flyers.splice(vm.flyersMap[flyer.id].pos, 1);
                    loadShowcasesFlyers();
                } else {
                    vm.showcase.flyers.splice(0, 0, flyer);
                    loadShowcasesFlyers();
                }
            } else {
                vm.showcase.flyers.splice(0, 0, flyer);
                loadShowcasesFlyers();
            }
        };

        vm.changeTemplate = function (templateId) {
            vm.templateIsLoading = true;
            vm.templateId = templateId;
            loadTemplate().then(function () {
                vm.showcase.showcaseTemplateId = templateId;
            });
        };


        vm.getImageSrc = function (templateId) {
            return 'content/images/templates/' + templateId + '.png';
        };


        function succesPrint(res) {

            var saveByteArray = (function() {
                return function(data, name, mimeType) {
                    var blob = new Blob(data, {
                        type: mimeType
                    });
                    var url = window.URL.createObjectURL(blob);
                    var element = angular.element('<a/>');
                    element.attr({
                        href: url,
                        target: '_blank',
                        download: name
                    });
                    if(document.createEvent) {
                        var ev = document.createEvent("MouseEvent");
                        ev.initMouseEvent("click", true /* bubble */, true /* cancelable */, window, null, 0, 0, 0, 0, /* coordinates */
                        false, false, false, false,
                        /*
                         * modifier keys
                         */
                        0 /* left */, null);
                        element[0].dispatchEvent(ev);
                    } else {
                        element[0].fireEvent("onclick");
                    }
                    setTimeout(function() {
                        document.body.removeChild;
                        window.URL.revokeObjectURL(url);
                    }, 200);
                };
            }());
            if (res.headers["content-disposition"]){
                var filename = res.headers["content-disposition"].match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1];
                var mimeType = res.headers["content-type"];
                filename = filename.replace(/['"]/g, '');
                saveByteArray([res.data], filename, mimeType);
            } else {
                toastr.error($translate.instant('showcases.messages.tabloid.error.erroByGenerateCatalog'));
            }

            vm.isPrinting = false;
            $rootScope.$emit('finish-generate-tabloid');
        }

        function errorPrint(response) {
            vm.isPrinting = false;
            $rootScope.$emit('finish-generate-tabloid');
            toastr.error($translate.instant('showcases.messages.tabloid.error.erroByGenerateCatalog'));

        }

        vm.generateTabloid = function(){
            vm.saveFlyer(false, function () {
                if (!vm.showcase.hasCover) {
                    toastr.error($translate.instant('showcases.messages.errors.blankCover'));
                    vm.isSaving = false;
                } else if (vm.showcase.flyers.length < 1) {
                    toastr.error($translate.instant('showcases.messages.errors.blankFlyers'));
                } else if (!vm.showcase.name) {
                    toastr.error($translate.instant('showcases.messages.errors.blankName'));
                } else {
                    vm.isPrinting = true;
                    buildMessageGeneratedTabloid();
                    $rootScope.$emit('waiting-generates-tabloid');
                    ShowcasesService.generateTabloid({
                        showcaseId: Number(vm.showcase.id) || undefined,
                        storeId: ( storeId ? storeId + "" : undefined) || undefined,
                        flyers: vm.showcase.flyers.map(function (flyer) {
                            return flyer.id;
                        })
                    }).then(succesPrint, errorPrint);
                }
            });
        }


        function loadShowcasesFlyers() {
            if (vm.showcase.flyers) {
                vm.flyerId = 0;
                if (vm.showcase.showcaseTemplateId) {
                    vm.templateId = vm.showcase.showcaseTemplateId;
                }
                vm.showcase.flyers.forEach(function (flyer) {
                    enrichShowcaseFlyer(flyer);
                });
            }
            loadTemplate();
        }


        function loadTemplate() {
            return ShowcasesService.getTemplate(vm.templateId).then(function (response) {
                vm.template = response;
                vm.templateIsLoading = false;
            });
        }

        function openShowcaseModalType() {
            userInteractModal = UserInteractModalFactory.selectUserInterectType(storeId, vm.showcase.userInteract);
            userInteractModal.result.then(function (userInteract) {

                vm.originalUserInteract = angular.copy(vm.showcase.userInteract);
                vm.showcase.userInteract = userInteract;

                vm.listFilter.type = vm.showcase.userInteract;
                if (!(vm.originalUserInteract && vm.originalUserInteract === vm.showcase.userInteract)) {
                    vm.flyersInfo = null;
                    vm.flyersFiltered = [];
                    vm.flyersMap = undefined;
                    vm.showcase.flyers = [];
                    loadShowcasesFlyers();
                }
            });
        }

        function setShowcaseTypeDefault() {
            vm.showcase.userInteract = DEFAULT_TYPE;
            vm.listFilter.type = vm.showcase.userInteract;
        }

        vm.getShowcasesFlyer = function () {
            vm.saveFlyer(true);
        }

        vm.goToFlyerByShowkase = function() {
            if (vm.showcase && vm.showcase.id) {
                vm.preSaveFlyer(true);
            } else {
                vm.saveFlyer(true);
            }
        };

        vm.goToLayoutTemplates = function() {
            if (vm.showcase.customHtml) {
                toastr.warning($translate.instant('showcases.messages.errors.customHtmlConfigured'));
                return;
            }
            if (vm.showcase && vm.showcase.id) {
                vm.preSaveFlyer(true, 'layout-templates');
            } else {
                vm.saveFlyer(true, null, true, 'layout-templates');
            }
        };

        function redirectAfterShowcaseSave(data, redirectTarget) {
            if (!redirectTarget || !data) {
                return;
            }

            if (redirectTarget === 'layout-templates') {
                $state.go('showcases-layout-templates', {
                    showcaseId: data.id,
                    ownerId: data.ownerId
                });
                return;
            }

            $state.go('showcases-flyers', {
                showcaseId: data.id,
                ownerId: data.ownerId
            });
        }

        vm.saveFlyerPreview = function (isRedirectToFlyersScreen, callback) {
            vm.isSaving = true;
            mergeShownShowcaseFlyersToShowcase().then(function () {
                vm.showcase.showcaseTemplateId = vm.templateId;
                if (vm.showcase.flyers.length >= 1 && vm.showcase.name) {
                    vm.showcase.cover = "";
                    vm.saveCover(function () {
                        if (vm.showcase.addImageFileDTO.length > 0) {
                            var flyersPosition = [];
                            vm.showcase.flyers.forEach(function (flyer) {
                                flyersPosition.push({
                                        flyerId: flyer.id,
                                        position: flyer.position
                                    });
                            });
                            vm.showcase.flyers = flyersPosition;
                            $q.all(vm.showcase.flyers).then(function (data) {
                                if (vm.showcaseId) {
                                    ShowcasesService.updateShowcase(vm.showcase).then(function (data) {
                                        if (isRedirectToFlyersScreen) {
                                            $state.go('showcases-flyers', {
                                                showcaseId: data.id
                                            });
                                        } else {
                                            toastr.success($translate.instant('showcases.messages.update.success'));
                                            vm.isSaving = false;
                                        }
                                        if (callback) {
                                            callback(true);
                                        }
                                        vm.showcase.flyers = vm._shownShowcaseFlyersBeforeMerge ? vm._shownShowcaseFlyersBeforeMerge.slice() : [];
                                        vm.isShowcaseFlyersSaveListLoading = false;
                                        vm.isSavingPreview = false;
                                    }, function (data) {
                                        toastr.error($translate.instant('showcases.messages.update.error'));
                                        vm.showcase.flyers = vm._shownShowcaseFlyersBeforeMerge ? vm._shownShowcaseFlyersBeforeMerge.slice() : [];
                                        vm.isShowcaseFlyersSaveListLoading = false;
                                        vm.isSavingPreview = false;
                                        vm.isSaving = false;
                                    });
                                } else {
                                    ShowcasesService.saveShowcase(vm.showcase).then(function (data) {
                                        vm.showcase = data;
                                        toastr.success($translate.instant('showcases.messages.create.success'));
                                        vm.isSavingPreview = false;
                                        if (callback) {
                                            callback(true);
                                        }
                                        vm.showcase.flyers = vm._shownShowcaseFlyersBeforeMerge ? vm._shownShowcaseFlyersBeforeMerge.slice() : [];
                                        vm.isShowcaseFlyersSaveListLoading = false;
                                    }, function (data) {
                                        toastr.error($translate.instant('showcases.messages.create.error'));
                                        vm.showcase.flyers = vm._shownShowcaseFlyersBeforeMerge ? vm._shownShowcaseFlyersBeforeMerge.slice() : [];
                                        vm.isShowcaseFlyersSaveListLoading = false;
                                        vm.isSavingPreview = false;
                                    });
                                }
                            });
                        } else if (!vm.showcase.cover) {
                            toastr.error($translate.instant('showcases.messages.errors.blankCover'));
                            vm.isShowcaseFlyersSaveListLoading = false;
                        }
                    });
                } else if (vm.showcase.flyers.length < 1) {
                    toastr.error($translate.instant('showcases.messages.errors.blankFlyers'));
                    vm.isShowcaseFlyersSaveListLoading = false;
                } else if (!vm.showcase.name) {
                    toastr.error($translate.instant('showcases.messages.errors.blankName'));
                    vm.isShowcaseFlyersSaveListLoading = false;
                }
            }, function () {
                toastr.error($translate.instant('showcases.messages.errors.prepareSave'));
                vm.showcase.flyers = vm._shownShowcaseFlyersBeforeMerge ? vm._shownShowcaseFlyersBeforeMerge.slice() : [];
                vm.isShowcaseFlyersSaveListLoading = false;
            });
        }

        vm.preSaveFlyer = function(isToRedirect, redirectTarget) {
            vm.isSaving = true;
            if (vm.showcase && vm.showcase.id) {
                return ShowcasesService.getShowcase(vm.showcase.id, vm.showcase.ownerId, false).then(
                    function(response) {
                        vm._showcase = response;

                        var isAfter = moment(vm._showcase.updatedAt).isAfter(moment(vm.showcase.updatedAt)); // true

                        if (isAfter) {
                            ModalFactory.openSimpleModal(
                                "ATENÇÃO!",
                                "Identificamos alterações recentes na vitrine que você está prestes a alterar, deseja realmente confirmar suas alterações e descartar a versão anteriormente criada?",
                                "Confirmar",
                                "Cancelar",
                                function() {
                                    return vm.saveFlyer(isToRedirect, null, true, redirectTarget);
                                }
                            );
                            vm.isSaving = false;
                        } else {
                            vm.saveFlyer(isToRedirect, null, true, redirectTarget);
                        }
                    },
                    function () {
                        toastr.error($translate.instant('showcases.messages.errors.checkingChanges'));
                        vm.isSaving = false;
                    }
                );
            } else {
                vm.saveFlyer(isToRedirect, null, true, redirectTarget);
            }
        };


        vm.saveFlyer = function (isRedirectToSecondaryScreen, callback, isSaving, redirectTarget) {
            vm.isSaving = angular.isUndefined(isSaving) ? true : isSaving;
            var resolvedRedirectTarget = isRedirectToSecondaryScreen ? (redirectTarget || 'flyers') : null;
            mergeShownShowcaseFlyersToShowcase().then(function () {
                vm.showcase.showcaseTemplateId = vm.templateId;
                vm.showcase.cover = "";
                vm.saveCover(function () {
                    var flyersPosition = [];
                    vm.showcase.flyers.forEach(function (flyer, index) {
                        flyersPosition.push({
                            flyerId: flyer.id,
                            position: index + 1
                        });
                    });
                    vm.showcase.flyers = flyersPosition;
                    var banners = angular.copy(vm.showcase.addImageFileDTO);
                    vm.showcase.addImageFileDTO.forEach(function (banner, index) {
                        banners[index].nameFile = vm.banners[index].name;
                        banners[index].action = vm.banners[index].link;
                    });
                    vm.showcase.addImageFileDTO = banners;

                    $q.all(vm.showcase.flyers).then(function (data) {
                        if (vm.showcaseId) {
                            ShowcasesService.updateShowcase(vm.showcase).then(function (data) {
                                vm.showcase = data;
                                vm.banners = vm.showcase.banners;
                                vm.showcase.banners.forEach(function(banner, i) {
                                    vm.banners[i].image = vm.showcase.coverUrl.split("showcase")[0] + vm.banners[i].cover;

                                    if (vm.banners[i].coverMobile) {
                                        vm.banners[i].imageMobile = vm.showcase.coverUrl.split("showcase")[0] + vm.banners[i].coverMobile;
                                    }
                                })

                                if (resolvedRedirectTarget) {
                                    redirectAfterShowcaseSave(data, resolvedRedirectTarget);
                                } else {
                                    toastr.success($translate.instant('showcases.messages.update.success'));
                                    vm.isSaving = false;
                                }
                                if (callback) {
                                    callback(true);
                                }
                                vm.showcase.flyers = vm._shownShowcaseFlyersBeforeMerge ? vm._shownShowcaseFlyersBeforeMerge.slice() : [];
                                vm.isShowcaseFlyersSaveListLoading = false;

                            }, function (data) {
                                vm.showcase.flyers = vm._shownShowcaseFlyersBeforeMerge ? vm._shownShowcaseFlyersBeforeMerge.slice() : [];
                                vm.isShowcaseFlyersSaveListLoading = false;
                                vm.isSaving = false;
                                if (resolvedRedirectTarget) {
                                    toastr.error($translate.instant('showcases.messages.update.error'));
                                }
                            });
                        } else {
                            ShowcasesService.saveShowcase(vm.showcase).then(function (data) {
                                vm.isSaving = false;
                                vm.showcase = data;
                                if (resolvedRedirectTarget) {
                                    redirectAfterShowcaseSave(data, resolvedRedirectTarget);
                                } else {
                                    toastr.success($translate.instant('showcases.messages.create.success'));
                                }
                                if (callback) {
                                    callback(true);
                                    vm.isSaving = false;
                                }
                                vm.showcase.flyers = vm._shownShowcaseFlyersBeforeMerge ? vm._shownShowcaseFlyersBeforeMerge.slice() : [];
                                vm.isShowcaseFlyersSaveListLoading = false;
                            }, function (data) {
                                vm.showcase.flyers = vm._shownShowcaseFlyersBeforeMerge ? vm._shownShowcaseFlyersBeforeMerge.slice() : [];
                                vm.isShowcaseFlyersSaveListLoading = false;
                                vm.isSaving = false;
                                if (resolvedRedirectTarget) {
                                    toastr.error($translate.instant('showcases.messages.create.error'));
                                }
                            });
                        }
                    });
                });
            }, function () {
                toastr.error($translate.instant('showcases.messages.errors.prepareSave'));
                vm.showcase.flyers = vm._shownShowcaseFlyersBeforeMerge ? vm._shownShowcaseFlyersBeforeMerge.slice() : [];
                vm.isShowcaseFlyersSaveListLoading = false;
            });
        }

        vm.setBackgroundColor = function (color) {
            vm.showcase.backgroundColor = color;
        }

        vm.getCategoryName = function (flyer) {
            var category = _.find(vm.categories, function(el) {return el.key === flyer.categoryKey});
            if (category) {
                flyer.category = category.title;
            }
        }

        vm.getFlyerCurrency = function (currency) {
            return FlyersCurrencyValue[currency];
        }

        vm.loadFlyer = function () {
            vm.flyerId++;
            vm.flyersToLoad--;
        }

        vm.checkIfShowcasePublished = function () {
            if (vm.showcase.published) {
                return true;
            } else {
                return false;
            }
        }

        vm.getBackgroundImg = function (flyerId) {
            return ('\'/flyer/api/' + flyerId + '/picture\'');
        }

        function getStoreInfo() {
            return StoreService.getStore($localStorage.defaultStore.storeId);
        }

        getStoreInfo().then(function(response) {
            $localStorage.defaultStore.storeType = response.data.storeType;
            vm.store = response.data;
        });

        function showMessagePublishShowcase() {
            if (!$localStorage.defaultStore.storeNickname){
                getStoreInfo().then(function(response) {
                    $localStorage.defaultStore.storeNickname = response.data.nickname;
                    $localStorage.defaultStore.storeType = response.data.storeType;
                    vm.store = response.data;
                    buildMessagePublishShowcase();
                });
            } else {
                buildMessagePublishShowcase();
            }
        }

        function buildMessagePublishShowcase() {
            var url = vm.store && vm.store.redirectURL ? 
                $window.location.protocol + '//' + vm.store.redirectURL : 
                'http://' + $localStorage.defaultStore.storeNickname.toLowerCase() + "." + getDomainNameSufix($window, vm.store.storeType);

            ModalFactory.openModal(null,
                $translate.instant('showcases.messages.publish.successTitle', {
                showcaseType: $translate.instant('global.showcaseTypes.' + vm.showcase.userInteract) }),
                $translate.instant('showcases.messages.publish.successSubtitle', {
                    url: url }),
                null, $translate.instant('showcases.messages.publish.goToShowcase'),
                'OK', function(){$window.open(url, '_blank');},
                null, null, 'icon-ksc-showcasepublished');
        }

        function buildMessageGeneratedTabloid() {
            ModalFactory.openModal(null,
                'showcases.messages.tabloid.readyTabloid',
                null, null, 'OK', null, 'close',null, null, null,
                'showcases.messages.tabloid.ifNotDownloaded', 'showcases.messages.tabloid.clickHere',
            function(callback){
                ShowcasesService.generateTabloid({
                    showcaseId: Number(vm.showcase.id) || undefined,
                    storeId: ( storeId ? storeId + "" : undefined) || undefined,
                    flyers: vm.showcase.flyers.map(function (flyer) {
                        return flyer.id;
                    })
                }).then(function(res) {
                    var saveByteArray = (function() {
                        return function(data, name, mimeType) {
                            var blob = new Blob(data, {
                                type: mimeType
                            });
                            var url = window.URL.createObjectURL(blob);
                            var element = angular.element('<a/>');
                            element.attr({
                                href: url,
                                target: '_blank',
                                download: name
                            });
                            if(document.createEvent) {
                                var ev = document.createEvent("MouseEvent");
                                ev.initMouseEvent("click", true /* bubble */, true /* cancelable */, window, null, 0, 0, 0, 0, /* coordinates */
                                false, false, false, false,
                                /*
                                 * modifier keys
                                 */
                                0 /* left */, null);
                                element[0].dispatchEvent(ev);
                            } else {
                                element[0].fireEvent("onclick");
                            }
                            setTimeout(function() {
                                document.body.removeChild;
                                window.URL.revokeObjectURL(url);
                            }, 200);
                        };
                    }());
                    if (res.headers["content-disposition"]){
                        var filename = res.headers["content-disposition"].match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1];
                        var mimeType = res.headers["content-type"];
                        filename = filename.replace(/['"]/g, '');
                        saveByteArray([res.data], filename, mimeType);
                    } else {
                        toastr.error($translate.instant('showcases.messages.tabloid.error.erroByGenerateCatalog'));
                    }
                    vm.isPrinting = false;
                    callback();
                }, function(response) {
                    vm.isPrinting = false;
                    callback();
                });
            }, 'width: 143px; height: 170px;', 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/download-tabloide.png');
        }

        function storeOwnerHasMoipAccount() {
            Principal.storeOwnerHasMoipAccount().then(function (responseMoipAccount) {
                vm.storeOwnerHasMoipAccount = responseMoipAccount.data != null && responseMoipAccount.data.moipLogin != null;
            });
        }

        vm.openModalConfirmCatalogChange = function(showcaseId) {
            ModalFactory.openModal(null,
                $translate.instant('showcases.messages.publish.msgModal'),
                null,
                null, $translate.instant('showcases.home.buttons.publishShowcase'),
                $translate.instant('showcases.home.buttons.no'), function(){
                    vm.publishShowcase(showcaseId);
                },
                null, null, 'icon-warning', null, null, null, null, null, {'font-size': '1.6em'}, true);
        }

        vm.publishShowcase = function () {
            vm.isPublishing = true;
            if (!vm.showcase.hasCover && vm.coverEdit) {
                toastr.warning($translate.instant('showcases.messages.errors.blankCover'));
                vm.isSaving = false;
                vm.isPublishing = false;
            } else if (vm.showcase.flyers.length < 1 && !vm.showcase.customHtml) {
                toastr.warning($translate.instant('showcases.messages.errors.blankFlyersAndNullCustomHtml'));
                vm.isPublishing = false;
                vm.isSaving = false;
            } else if (!vm.showcase.name) {
                toastr.warning($translate.instant('showcases.messages.errors.blankName'));
                vm.isPublishing = false;
                vm.isSaving = false;
            } else {
                vm.saveFlyer(false, function () {
                    ShowcasesService.publishShowcase(vm.showcase.id).then(function(data) {
                        vm.isPublishing = false;
                        showMessagePublishShowcase();
                        $state.go('showcases');
                    }, function(data) {
                        if (data.headers("errorKey")){
                            toastr.error($translate.instant('showcases.messages.publish.errors.' + data.headers("errorKey")));
                        } else {
                            toastr.error($translate.instant('showcases.messages.publish.errors.genericError'));
                        }

                        vm.isPublishing = false;
                    });
                });
            }
        }

        vm.openInput = function (evt) {
            document.getElementById('fileInput').click();
        }

        vm.getPreviewURL = function (showcase) {
            if (showcase.id) {
                vm.openPreviewURL();
            } else {
                if (vm.saveFlyerPreview(false, function (data) {
                        if (data) {
                            $timeout(function (data) {
                                vm.openPreviewURL();
                            }, 1000);
                        }
                    }));
            }
        };

        vm.openPreviewURL = function () {
            var url = vm.store && vm.store.redirectURL ? 
                $window.location.protocol + '//' + vm.store.redirectURL : 
                'http://' + $localStorage.defaultStore.storeNickname + '.' + getDomainNameSufix($window, vm.store ? vm.store.storeType : $localStorage.defaultStore.storeType);
            $window.open(url + '/preview/' + vm.showcase.id, '_blank');
        };

        function dataURItoBlob(dataURI) {
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0)
                byteString = atob(dataURI.split(',')[1]);
            else
                byteString = unescape(dataURI.split(',')[1]);
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ia], {
                type: mimeString
            });
        }

        vm.saveCover = function (callback) {
            vm.showcase.addImageFileDTO = [];

            if(vm.banners && (vm.banners.length === 0 ||  (vm.banners.length === 1 && vm.banners[0].image.indexOf(DEFAULT_IMAGE) != -1) )) {
                vm.loadingImage = false;
                if (callback) {
                    callback();
                }
            } else {
                var arr = Array.from(Array(vm.banners.length).keys());
                var aux = [];

                var index = 0;
                var orderNumber = 0;
                var blob = dataURItoBlob(vm.banners[index].image);
                var mobileImage = vm.banners[index].imageMobile;
                saveFlyerMultiImage(blob, arr, aux, index, orderNumber, mobileImage, callback);
            }
        }

        function saveFlyerMultiImage(blob, arr, aux, i, orderNumber, hasMobileImage, callback) {
            if (i === vm.banners.length) return;

            hasMobileImage = vm.banners[i].imageMobile;
            blob = dataURItoBlob(vm.banners[i].image);

            FlyersService.saveFlyerMultiImage(blob, i).then(function (response) {
                $timeout(function () {
                    if (response.data) {
                        aux.push('');
                        vm.showcase.hasCover = true;
                        if (hasMobileImage) {
                            var blobImageMobile = dataURItoBlob(vm.banners[i].imageMobile);
                            orderNumber = orderNumber + 1;
                            FlyersService.saveFlyerMultiImage(blobImageMobile, orderNumber).then(function (responseMobile) {
                                if (responseMobile) {
                                    response.data.mobileImageFile = responseMobile.data;
                                    arr[response.data.orderNumber] = response.data;
                                    if (aux.length === vm.banners.length) {
                                        vm.showcase.addImageFileDTO = arr;
                                        callback();
                                    }
                                    i = i + 1;
                                    saveFlyerMultiImage(blob, arr, aux, i, orderNumber, hasMobileImage, callback);
                                } else {
                                    vm.isShowcaseFlyersSaveListLoading = false;
                                    toastr.error($translate.instant('flyers.messages.create.image.uploadError'));
                                }
                            }, function () {
                                vm.isShowcaseFlyersSaveListLoading = false;
                                toastr.error($translate.instant('flyers.messages.create.image.uploadError'));
                            });
                        } else {
                            response.data.hasMobileImage = false;
                            arr[response.data.orderNumber] = response.data;
                            orderNumber = orderNumber + 1;
                            if (aux.length === vm.banners.length) {
                                vm.showcase.addImageFileDTO = arr;
                                callback();
                            }
                            i = i + 1;
                            saveFlyerMultiImage(blob, arr, aux, i, orderNumber, hasMobileImage, callback);
                        }
                    } else {
                        toastr.error($translate.instant('flyers.messages.create.error'));
                        vm.isShowcaseFlyersSaveListLoading = false;
                    }
                    vm.loadingImage = false;
                });
            }, function (response) {
                toastr.error($translate.instant('flyers.messages.create.image.uploadError'));
                vm.isShowcaseFlyersSaveListLoading = false;
                vm.loadingImage = false;
            });
        }

		window.onDesignPublishCallback = function (data) {
		  var exportUrl = data.exportUrl;
		  var designId = data.designId;
		  loadImageToCroppieByURLCanvas(exportUrl);
		  //sendDataViaAjax (exportUrl, designId);
		}

        function openBannersModal() {
            vm.openAddBannersModal();
        }

        function removeBanner(index) {
            var carousel = document.getElementById("carousel");

            vm.banners.splice(index, 1);
            if (vm.banners.length === 0) {
                vm.haveBanners = false;
                vm.showcase.hasCover = false;
                vm.coverEdit = true;

                while(carousel.firstChild) {
                    carousel.removeChild(carousel.firstChild);
                }

                $scope.$apply();
            } else {
                loadCarousel();
            }
        }

        function loadCarousel() {
            var carousel = document.getElementById("carousel");

            while(carousel.firstChild) {
                carousel.removeChild(carousel.firstChild);
            }

            var counter = vm.banners.length;
            if(counter > 0) {
                carousel.style.display = 'block';
                var reversedBanners = vm.banners.slice().reverse();
                reversedBanners.forEach(function (banner) {
                    var name = banner.name;
                    if (name.length > 20) {
                        name = name.slice(0, 20).concat('...');
                    } else if (name.length == 0) {
                        name = "[SEM NOME]"
                    }

                    var srcImage = vm.isMobile
                        ? (banner.imageMobile ? banner.imageMobile : banner.image)
                        : banner.image;
                    if (srcImage.split(',')[0].indexOf('base64') == -1) {
                        srcImage += '?dummy=' + new Date().getTime();
                    }
                    carousel.insertAdjacentHTML(
                        "afterbegin",
                            ' <div class="carousel__item" style=" height: 100%; width: 100%;"> ' +
                        '<img id="img" style=" width: 100%; object-fit: cover; max-height: 100%;" src="' + srcImage + '"  alt="">  ' +
                        '<div style="width: 100%; position: absolute; bottom: 0; left: 0; text-align: center;" class="hidden-xs hidden-sm"> ' +
                        '<div class="carousel__title col-md-5">' + counter + 'º Banner <span class="carrousel__banner__name"> - ' + name + ' </span> ' +
                        '<span class="fa fa-edit" style="z-index: 10; color: #5b5b5b !important;"> </span> ' +
                        '<span class="fa fa-trash" style="z-index: 10; color: #5b5b5b !important; margin-left: 8px"> </span> </div> </div> </img> </div> '
                        );
                    counter--;
                    });

                var items = carousel.querySelectorAll(".carousel__item");


                var buttonsHtml = Array.from(items, function () {
                    return '<span class="carousel__button"></span>';
                });

                carousel.insertAdjacentHTML(
                    "beforeend",
                    ' <div class="carousel__nav">' + buttonsHtml.join("") + ' </div> ' );

                var carouselButtons = carousel.querySelectorAll(".carousel__button");
                carouselButtons.forEach(function (button, i) {
                        button.addEventListener("click", function() {
                            // un-select all the items
                            items.forEach(function (item) {
                                item.classList.remove("carousel__item--selected")
                                });
                            carouselButtons.forEach(function (button) {
                                button.classList.remove("carousel__button--selected")
                                });

                            items[i].classList.add("carousel__item--selected");
                            button.classList.add("carousel__button--selected");
                            vm.selectedBanner = i;
                        });
                    });

                // Select the first item on page load
                items[0].classList.add("carousel__item--selected");
                carouselButtons[0].classList.add("carousel__button--selected");

                // ARROW BUTTONS
                if (reversedBanners.length > 1) {
                    carousel.insertAdjacentHTML(
                        "beforeend",
                        ' <div class="backward_button arrow_buttons col-md-1"> <i class="fa fa-chevron-left carousel_arrows"></i> </div> ' );

                    carousel.insertAdjacentHTML(
                        "beforeend",
                        ' <div class="forward_button arrow_buttons col-md-1" style="margin-left: 91%"> <i class="fa fa-chevron-right carousel_arrows"></i> </div> ' );

                    var backwardButton = carousel.querySelectorAll(".backward_button");
                    backwardButton.forEach(function (button, i) {
                        button.addEventListener("click", function (){
                            // un-select all the items
                            items.forEach(function (item) {
                                    item.classList.remove("carousel__item--selected")
                                });
                            carouselButtons.forEach(function (button) {
                                    button.classList.remove("carousel__button--selected")
                                });

                            var index = vm.selectedBanner -= 1;
                            if (index < 0) {
                                index = 0;
                            }
                            vm.selectedBanner = index;
                            items[index].classList.add("carousel__item--selected");
                            carouselButtons[index].classList.add("carousel__button--selected");
                        });
                    });

                    var forwardButton = carousel.querySelectorAll(".forward_button");
                    forwardButton.forEach(function (button, i) {
                        button.addEventListener("click", function () {
                            // un-select all the items
                            items.forEach(function (item) {
                                item.classList.remove("carousel__item--selected")
                            });
                            carouselButtons.forEach(function (button){
                                button.classList.remove("carousel__button--selected")
                            });

                            var index = vm.selectedBanner += 1;
                            if (index > reversedBanners.length - 1) {
                                index = reversedBanners.length - 1;
                            }
                            vm.selectedBanner = index;
                            items[index].classList.add("carousel__item--selected");
                            carouselButtons[index].classList.add("carousel__button--selected");
                        });
                    });
                }


                vm.selectedBanner = 0;

                // BUTTON ACTIONS
                var editButtons = carousel.querySelectorAll(".fa-edit");
                editButtons.forEach(function (button, i) {
                    button.addEventListener("click", function() {
                        openBannersModal();
                    });
                });

                var trashButtons = carousel.querySelectorAll(".fa-trash");
                trashButtons.forEach(function (button, i) {
                    button.addEventListener("click", function(){
                        removeBanner(i);
                    });
                });

                }
        }


		$scope.$on("$destroy", function () {
            if (!angular.isUndefined(userInteractModal)) {
                userInteractModal.close();
            }
        });

        vm.openAddBannersModal = function () {
            vm.filtersConversationModal = $uibModal.open({
                templateUrl: 'app/admin/showcases/banner-modal/banners_modal.html',
                controller: 'BannersModalController',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'lg',
                keyboard: false,
                resolve: {
                    banners: function () {
                        return vm.banners;
                    },
                    userAccount: function () {
                        return null;
                    },
                },
            }).result.then(function (response) {
                if (response) {
                    vm.banners = response.banners;
                    vm.haveBanners = true;
                    vm.showcase.hasCover = true;
                    loadCarousel();
                }
            });
        }

        vm.openAddCustomHtmlModal = function () {
            if (vm.showcase.layoutTemplate) {
                toastr.warning($translate.instant('showcases.messages.errors.layoutTemplateConfigured'));
                return;
            }
            $uibModal.open({
                templateUrl: 'app/admin/showcases/custom-html-modal/custom-html-modal.html',
                controller: 'CustomHtmlModalController',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'lg',
                keyboard: false,
                resolve: {
                    customHtml: function () {
                        return vm.showcase.customHtml
                    }
                },
            }).result.then(function (response) {
                if (response) {
                    vm.showcase.customHtml = response.customHtml;
                }
            });
        }
    }
})();
